import React from "react";
import { FieldConfig } from "../components/common/forms/Interfaces";

interface Context {
  config: { [key: string]: FieldConfig };
  errors: { [key: string]: string[] | null };
}

const FormContext = React.createContext<Context>({
  config: {},
  errors: {},
});

export default FormContext;
